export type UserDTO = {
  id: string;
  name: string;
  surname: string;
  birthDate: string;
  gender: string;
  email: string;
  phone: string;
  countryCode: string;
  zip: string;
  address: string;
  complement: string | undefined;
  password: string;
  city: string | undefined;
  state: string | undefined;
  picture: string | undefined;
};

export const mapSignUpToUserBackEnd = (user: UserDTO): UserDTO => {
  return {
    ...user,
    phone: user.phone.replace(/[^a-zA-Z0-9 ]/g, ''),
  };
};
